const sortByNewestYear = (a, b) => b.value - a.value

const getYearsOptionsList = (from = 1971) => {
  const to = new Date().getFullYear() + 1
  return Array.from({ length: to - from }, (_, number) => ({
    label: number + from,
    value: number + from,
  })).sort(sortByNewestYear)
}

export { getYearsOptionsList }
